import { createContext, useContext, useCallback } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { CALENDLY } from "@/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const requestValidation = (payload) => axios.post(`${API}/validation-request`, payload);

export const calendlyUrl = (ctx = {}) => {
  const notes = [ctx.plan && `Plan: ${ctx.plan}`, ctx.seats && `Seats: ${ctx.seats}`, ctx.stack?.length && `Stack: ${ctx.stack.join(", ")}`].filter(Boolean).join(" · ");
  const u = new URL(CALENDLY);
  if (ctx.source) u.searchParams.set("utm_source", ctx.source);
  if (notes) u.searchParams.set("a1", notes);
  return u.toString();
};

const BookingContext = createContext({ open: () => {} });
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const open = useCallback((ctx = {}) => window.open(calendlyUrl(ctx), "_blank", "noopener,noreferrer"), []);
  return <BookingContext.Provider value={{ open }}>{children}</BookingContext.Provider>;
};

export const DemoLink = ({ ctx = {}, className = "btn-primary", testId, children = "Book a demo" }) => (
  <a href={calendlyUrl(ctx)} target="_blank" rel="noopener noreferrer" className={className} data-testid={testId}>
    {children} <ArrowRight className="w-4 h-4" />
  </a>
);

